export default __webpack_public_path__ + "pie-chart-dark.a4a9afae.svg";